import axios from "axios";


export const fetchPatientStatusApiCall = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Lab/labTests
    `);

}


